import {
  CustomLabel,
  FlexContainer,
  IconButton,
} from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

export const InvoicePopupWrapper = styled.div`
  > div,
  div.collapsed-invoice-popup > div {
    display: flex;
    /* align-items: center; */
    margin-bottom: 25px;
    > ${CustomLabel},>div {
      &:first-child {
        margin-right: 10px;
        min-width: 150px;
        width: 22%;
        ${CustomLabel}:not(.semi-header) {
          font-size: 16px;
          font-weight: 400;
          &:not(.standard-lh) {
            line-height: 40px;
          }
        }
        ${CustomLabel}.semi-header {
          font-size: 17px;
          font-weight: 700;
          line-height: 20px;
          margin: 5px 0px 35px;
        }
      }
      &:last-child {
        flex: 1 1 0;
      }
    }
    .item-icon {
      img {
        height: 20px;
        width: 20px;
      }
    }
  }
  .invoice-description-block {
    ${CustomLabel} {
      width: 100%;
      textarea {
        width: 380px;
        height: 70px;
      }
    }
  }
  .invoice-payment-due {
    input {
      height: 40px;
      width: 200px;
    }
  }
  .invoice-timezone {
    align-items: center;
    &.subscription-timezone .styled-input {
      width: 110px;
    }
    .header {
      padding: 0px 5px;
    }
    .select-header-icon {
      margin-bottom: 3px;
    }
  }
  .invoice-payment-datepicker {
    border: none !important;
    padding: 0px !important;
    .input {
      width: 100%;
      height: 40px;
      border: 1px solid #aaa;
      padding-left: 7px !important;
      .input-group-text {
        border-radius: 0px 4px 4px 0px;
      }
    }
  }
  ${IconButton} {
    min-width: 200px;
    height: 50px;
    border-radius: 10px;
    padding: 14px 12px;
    border: 1px solid #aaa;
    color: #555;
    &.active {
      border: 1px solid #57ac2d;
      background: #f7fff3;
    }
    img {
      height: 21px;
      width: 25px;
    }
    .invoice-icon {
      height: 21px;
    }
  }
  .invoice-payment-method {
    width: calc(100% + 114px);
    max-width: 100%;
    .header {
      max-width: 100%;
      width: calc(100% + 114px);
      /* padding: 4px 35px 4px 4px !important; */ // creating issue in new payment popup
      padding: 0px 35px 0px 4px !important;
      background-color: #fff;
      display: flex;
      align-items: center;
    }
    .options-menu {
      min-width: 360px;
      .dpdn-backup-btn {
        padding-right: 20px;
        flex: unset;
      }
      .dpdn-primary-btn {
        padding-left: 20px;
        flex: unset;
      }
    }
    .select-header-span {
      padding: 0px 6px;
      > div {
        gap: 30px;
        padding: 0px;
      }
    }
  }
  .white-bg {
    background-color: #fff;
  }
  .status-lh${CustomLabel} {
    line-height: 30px !important;
  }
  &.subscription-popup {
    .textarea-wrapper {
      width: auto;
      textarea {
        width: 415px;
        height: 70px;
        &::placeholder{
          color: #aaa;
        }
      }
    }
    > div {
      > ${CustomLabel},>div {
        &:first-child {
          line-height: 40px;
          width: 24.5%;
        }
        &:last-child {
          flex: 1 1 0;
        }
      }
    }
    > div.standard-lh {
      > ${CustomLabel},>div {
        &:first-child {
          line-height: 22px;
        }
      }
    }
    .subscription-merchant-account .header {
      width: 415px;
      max-width: 415px;
    }
    .subs-billing-btns {
      ${IconButton} {
        min-width: 197px;
        /* width: 155px; */
      }
    }
    .invoice-payment-method {
      .header {
        width: 415px;
        label {
          font-size: 16px;
          line-height: 24px;
        }
        .select-header-span,
        .options-menu {
          ${FlexContainer} {
            align-items: center;
          }
        }
      }
      .options-menu {
        width: 415px;
        max-height: 194px;
        label {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
    input.bill-every-input {
      width: 70px;
    }
    .bill-every-dpdn {
      width: 115px;
      .header {
        width: 115px;
      }
      .options-menu {
        width: 115px;
      }
    }
    .invoice-payment-datepicker {
      width: 183px;
      .input {
        padding-left: 0px;
        input {
          padding-left: 6px;
          &:focus {
            outline: none;
            box-shadow: none;
          }
          &.error-border {
            border: none !important;
          }
        }
      }
    }
    .subs-billing-dpdn {
      width: 150px;
      .header {
        width: 150px;
      }
    }
    .subs-billing-end-dpdn {
      width: 190px;
      .header {
        width: 190px;
      }
    }
    .input-wrapper {
      input.subs-billing-count {
        width: 80px;
      }
    }
    .subs-price-interval {
      .single-select-wrapper {
        width: 190px;
        .header {
          width: 190px;
          padding: 0px;
        }
      }
      .dollar-usd-input {
        input {
          width: 110px;
          height: 41px;
          padding-right: 43px;
          padding-left: 23px;
        }
        .input-wrapper {
          &::before {
            left: 8px;
          }
          &::after {
            right: 8px;
          }
        }
      }
    }
    .subs-recurring-fee {
      .single-select-wrapper {
        width: 220px;
        .header {
          width: 220px;
          padding: 0px !important;
        }
      }
    }
    .styled-input {
      line-height: normal;
    }
    .advanced-section-styles {
      margin: 15px 0px 25px;
      label {
        font-size: 20px !important;
        line-height: 24px !important;
        font-weight: 700 !important;
      }
      .fa-chevron-right {
        margin-bottom: 5px;
      }
    }
    .subscription-payment-method {
      .payment-form {
        width: 100%;
        max-width: 485px;
      }
    }
  }
  &.cancel-payment-popup {
    > div {
      gap: 70px;
    }
  }
  &.new-contact-popup {
    .styled-input,
    .input-wrapper {
      width: 100%;
    }
    .single-select-wrapper {
      width: 100%;
      .header {
        width: 100%;
      }
    }
    .country-dpdn {
      height: 40px;
      > div {
        height: 40px;
      }
      label,
      .custom-label {
        font-size: 16px;
      }
    }
    .country-phone-dpdn {
      label,
      .custom-label {
        font-size: 16px;
      }
    }
    .dropdown-menu {
      min-width: 180px;
    }
  }
  .payment-section > label,
  .payment-section > div {
    &:first-child {
      width: 70px;
    }
    &:nth-child(2) {
      width: 70px;
    }
    &:nth-child(3) {
      width: 100px;
    }
    &:last-child {
      width: 100px;
    }
  }
  .payment-section-wrapper hr {
    border: 2px solid #aaaaaa;
  }
  .save-draft-chkbx {
    input {
      margin-top: 10px !important;
    }
  }
  .billing-method-lh {
    > label {
      line-height: 48px !important;
    }
  }

  .balance-line {
    border: 1px solid #aaaaaa;
    width: 150px;
  }

  .pay-popup-warning {
    margin-bottom: 0px;
  }
  .input-label-lh {
    label {
      line-height: 38px !important;
    }
    .dollar-usd-input {
      .input-wrapper {
        position: relative;
        &::after {
          content: "USD";
          position: absolute;
          top: 50%;
          right: 12px;
          transform: translateY(-50%);
          font-size: 16px;
          color: #aaa;
        }
        &::before {
          content: "$";
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translateY(-50%);
          font-size: 18px;
          color: #555;
        }
      }
      input[type="text"] {
        width: 220px;
        padding-left: 30px;
        padding-right: 45px;
      }
    }
  }
  .seller-popup {
  }
  .card-body {
    width: 100% !important;
  }
  .collapsed-invoice-popup {
    width: 100%;
  }
  .collapsed-header-label {
    min-width: 50px !important;
    width: auto !important;
    font-size: 20px;
    line-height: normal !important;
    & + i {
      &.fa-chevron-right {
        margin-top: 6px;
        font-size: 14px;
      }
      &.fa-chevron-down {
        margin-top: 2px;
        font-size: 14px;
      }
    }
  }
  .logo-upload {
    align-items: flex-start !important;
  }
  ${FlexContainer} img.desc-plus-icon {
    height: 18px;
    width: 18px;
    cursor: pointer;
  }
  .desc-row-margin {
    margin-top: 32px;
  }
  .void-card {
    ${CustomLabel} {
      font-size: 16px;
    }
  }
  .more-fields-text {
    /* cursor: pointer;
        img{
            height: 16px;
            width: 16px;
        } */

    cursor: pointer;
    font-weight: 600;
    color: #556ab8;
    text-align: center;
    width: 100%;
    padding-left: 60px;
  }
  &.resume-subscription {
    .lh-40 {
      line-height: 40px;
    }
    .lh-outer-40 {
      > ${CustomLabel} {
        line-height: 40px;
      }
    }
    
  }
  .default-text{
    color: #555;
  }
  .pause-duration-block{
      .form-check-label{
        color: #555 !important;
      }
    }
`;
